import { PageableDataSourceV2, PageableListV2Dto, TemplateDirective } from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';
import { Observable } from 'rxjs';
import { EditorFieldType } from '../../enums/editor-field-type-enum.service';
import { AnexConfig } from '../anex-config.model';
import { EditorFieldConfigBase } from './editor-field-config-base.model';

export interface DataAutocompleteFieldConfigV2 extends EditorFieldConfigBase {
  type: EditorFieldType.DATA_AUTOCOMPLETE;

  valueToString: (value: object) => string;
  createNew: (search: string) => object;
  storage: PageableDataSourceV2<Observable<PageableListV2Dto<object>>, DataAutocompleteStorageParams<object>>;
  transformSelected?: (selected: object) => object | Observable<object>;

  storageParams?: Record<string, object | string | number | boolean>;
  optionTemplate?: TemplateDirective<object>;
  optionTemplate$?: Observable<TemplateDirective<object>>;
  notFoundMessage?: string;
  addButtonCaption?: string;
  allowEmpty?: boolean;
  allowCreate?: boolean;
  alwaysNewSearch?: boolean;
  emitEventWhenLoadedById?: boolean;
  prefix?: AnexConfig;
  suffix?: AnexConfig;
  clearValueAfterSelect?: boolean;
}
